import React, { useEffect, useRef, useMemo } from "react";
import { useSpring, animated } from "@react-spring/web";
import { Typography } from "@mui/material";

import UserPicture from "../../user-picture";
import UserItemMessage from "./user-item-message";

import StyledUserItem from "./styles";

const UserItem = ({
  profilePicture,
  name,
  surname,
  lastMessage,
  selected,
  height,
  onClick,
  styles = {},
  animatedStyles = {},
  read,
}) => {
  const unreadMessages = !read;

  return (
    <StyledUserItem onClick={onClick}>
      <div
        className="animation-wrapper"
        style={{
          transform: `translateY(${animatedStyles.translateY}px)`,
          transition: "transform 0.3s",
          ...styles,
        }}
      >
        <div className="user-item-cont">
          <div
            className={`user-item ${
              selected ? "user-item--selected" : "user-item--no-selected"
            }`}
          >
            <div className="user-item-content" style={{ height: height }}>
              <div className="user-picture-cont">
                <UserPicture
                  image={profilePicture}
                  name={name}
                  surname={surname}
                  size={45}
                  className={
                    unreadMessages ? "unread-message-user-picture" : ""
                  }
                />
                {unreadMessages ? <div className="unread-message"></div> : null}
              </div>
              <div className="user-item-text-cont">
                {name && surname && (
                  <Typography
                    variant="body2"
                    fontWeight={500}
                    sx={{
                      textOverflow: "ellipsis",
                      textWrap: "nowrap",
                      display: "block",
                    }}
                    className="user-item-text"
                  >
                    {`${name} ${surname}`}
                  </Typography>
                )}

                {lastMessage && lastMessage.content && (
                  <UserItemMessage {...lastMessage} />
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </StyledUserItem>
  );
};

export default UserItem;
